export const servicesData = [
  {
    id: 'refection',
    icon: 'ri-home-4-line',
    titleKey: 'service_refaction_title',
    descKey: 'service_refaction_desc',
  },
  {
    id: 'repair',
    icon: 'ri-drop-line',
    titleKey: 'service_repair_title',
    descKey: 'service_repair_desc',
  },
  {
    id: 'flat',
    icon: 'ri-layout-horizontal-line',
    titleKey: 'service_flat_title',
    descKey: 'service_flat_desc',
  },
  {
    id: 'metal',
    icon: 'ri-shield-check-line',
    titleKey: 'service_metal_title',
    descKey: 'service_metal_desc',
  },
  {
    id: 'inspection',
    icon: 'ri-search-line',
    titleKey: 'service_inspection_title',
    descKey: 'service_inspection_desc',
  },
  {
    id: 'snow',
    icon: 'ri-snowflake-line',
    titleKey: 'service_snow_title',
    descKey: 'service_snow_desc',
  },
];

export const whyUsData = [
  {
    id: 'speed',
    icon: 'ri-time-line',
    titleKey: 'whyus_1_title',
    descKey: 'whyus_1_desc',
  },
  {
    id: 'rbq',
    icon: 'ri-shield-star-line',
    titleKey: 'whyus_2_title',
    descKey: 'whyus_2_desc',
  },
  {
    id: 'guarantee',
    icon: 'ri-file-shield-line',
    titleKey: 'whyus_3_title',
    descKey: 'whyus_3_desc',
  },
  {
    id: 'price',
    icon: 'ri-hand-coin-line',
    titleKey: 'whyus_4_title',
    descKey: 'whyus_4_desc',
  },
];

export const processSteps = [
  {
    step: 1,
    titleKey: 'process_step1',
    descKey: 'process_step1_desc',
    icon: 'ri-chat-1-line',
  },
  {
    step: 2,
    titleKey: 'process_step2',
    descKey: 'process_step2_desc',
    icon: 'ri-search-line',
  },
  {
    step: 3,
    titleKey: 'process_step3',
    descKey: 'process_step3_desc',
    icon: 'ri-file-list-3-line',
  },
  {
    step: 4,
    titleKey: 'process_step4',
    descKey: 'process_step4_desc',
    icon: 'ri-hammer-line',
  },
];

export const testimonialsData = [
  {
    id: 1,
    textKey: 'testimonial_1_text',
    nameKey: 'testimonial_1_name',
    locationKey: 'testimonial_1_location',
    projectKey: 'testimonial_1_project',
    rating: 5,
    initials: 'ML',
    color: '#C77D3F',
  },
  {
    id: 2,
    textKey: 'testimonial_2_text',
    nameKey: 'testimonial_2_name',
    locationKey: 'testimonial_2_location',
    projectKey: 'testimonial_2_project',
    rating: 5,
    initials: 'PD',
    color: '#1B2A4E',
  },
  {
    id: 3,
    textKey: 'testimonial_3_text',
    nameKey: 'testimonial_3_name',
    locationKey: 'testimonial_3_location',
    projectKey: 'testimonial_3_project',
    rating: 5,
    initials: 'LR',
    color: '#C77D3F',
  },
];

export const faqData = [
  { id: 1, questionKey: 'faq_q1', answerKey: 'faq_a1' },
  { id: 2, questionKey: 'faq_q2', answerKey: 'faq_a2' },
  { id: 3, questionKey: 'faq_q3', answerKey: 'faq_a3' },
  { id: 4, questionKey: 'faq_q4', answerKey: 'faq_a4' },
  { id: 5, questionKey: 'faq_q5', answerKey: 'faq_a5' },
  { id: 6, questionKey: 'faq_q6', answerKey: 'faq_a6' },
];

export const zonesList = [
  'Saint-Romuald',
  'Saint-Nicolas',
  'Charny',
  'Pintendre',
  'Saint-Jean-Chrysostome',
  'Lévis centre',
  'Lauzon',
  'Saint-Étienne-de-Lauzon',
];